import { useEffect, useRef, useState } from "react";
import printJS from "print-js";

import BusinessSuiteContentLayout from "layout/business-suite-content/BusinessSuiteContentLayout";
import {
  Grid2x2,
  WalletCards,
  CircleStop,
  LoaderCircle,
  CircleOff,
  CircleCheck,
  PrinterCheck,
  AlignJustify,
  Calculator,
  Send,
  Loader,
  Plus,
  Settings,
  Minus,
  Calendar,
  BookUser,
  CircleAlert,
} from "lucide-react";
import { RequestApi, RouteApi, StatusMsg } from "utils";
import { useAppSelector } from "store/store";
import { AppLog } from "services";
import { Sheet, SheetClose, SheetContent, SheetFooter } from "components/ui/sheet";

import { Popover, PopoverContent, PopoverTrigger } from "components/ui/popover";
import { useLocation } from "react-router-dom";
import SearchBar from "components/app/search-bar/SearchBar";
import InfiniteScroll from "react-infinite-scroll-component";
import { AppRecord, AppRecordStatus } from "models/appRecord";
import ImageUrl from "components/app/image-url/ImageUrl";
import { ShimmerDepartmentRender, ShimmerStaffRender } from "components/app/shrimmer/Shrimmer";

import SkeletonMusicLibrariesTable from "pages/account-detail/music-libraries/skeleton/SkeletonMusicLibrariesTable";
import { useDispatch } from "react-redux";
import { setIndexTimeSheet } from "store/header";

import { noneProfile } from "assets";

import { Snackbar } from "components";

import HoverCardDetail from "pages/hover-card-detail/HoverCardDetail";

import { Select, SelectTrigger, SelectValue, SelectContent, SelectGroup, SelectLabel, SelectItem } from "components/ui/select"; // or wherever your library path is

import DailogLeave from "./dialogLeave/DailogLeave";
import { Service } from "utils/services";
import TimeSheetSetting from "./TimeSheetSetting";
import { Button } from "components/ui/button";
import NumberInput from "components/app/function/NumberInput";
import BtnGoToTop from "components/app/btn-go-to-top/BtnGoToTop";
import { boolean } from "zod";
import DailogLeaveDetail from "./dialogLeave/DailogLeaveDetail";
import DailogRecalculateLeave from "./dialogLeave/DailogRecalculateLeave";
import PageReportAttendanceTimesheets from "./dialogTimesheets/PageReportAttendanceTimesheets";
import PageDetailLeave from "./dialogLeave/PageDetailLeave";

export default function Leave() {
  const listRef = useRef<any>(null);
  const { bntSearch } = useAppSelector((state) => state.header);
  const [openDrawer, setOpenDrawer] = useState<number | null>(null);

  const currentYear = new Date().getFullYear();
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const years = Array.from({ length: 100 }, (_, i) => currentYear - i);

  const [dob, setDob] = useState(new Date().toISOString().split("T")[0]); // "2025-05-05"

  const dispatch = useDispatch();

  const [searchTextInput, setSearchTextInput] = useState<string>("");
  const [selectedProductGroupCode, setSelectedProductGroupCode] = useState<string>("");
  const [view, setView] = useState("card");
  const changeView = (selectedView: string) => {
    setView(selectedView);
    localStorage.setItem("leave", selectedView);
  };

  useState<boolean>(false);
  const { token } = useAppSelector((state) => state.auth);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const shopId = searchParams.get("id");
  const selectedProductGroupCodeRef = useRef(selectedProductGroupCode);
  const [selectProducts, setSelectProducts] = useState<boolean>(false);

  const [selectedProductIds, setSelectedProductIds] = useState<string[]>([]);

  const [hovered, setHovered] = useState(false);
  const handleClickDepartment = ({ departmentName }: { departmentName: string }) => {
    if (selectedProductGroupCode === departmentName) return;
    setSelectedProductGroupCode(departmentName);
    selectedProductGroupCodeRef.current = departmentName;
  };
  const loadingProductState = {
    currentPage: 1,
    currentIndex: 0,
    nextPageUrl: "",
    totalRecord: 0,
    loadingStatus: AppRecordStatus.loading,
  };

  // -----------------------------shop Employee-------------------------------------
  const [shopEmployeeLeave, setShopEmployeeLeave] = useState<any>();
  const [shopEmployeeLeaveLoading, setShopEmployeeLeaveLoading] = useState<any>(null);
  const [shopEmployeeLeaveLoadingState, setShopEmployeeLeaveLoadingState] = useState<any>(null);

  const getShopEmployeeLeaveSearch = async () => {
    setShopEmployeeLeaveLoadingState(true);
    try {
      const url = `${RouteApi.getShopEmployeeLeaveSearch}token=${token}`;
      const data = {
        shop_id: shopId,
        entitlement_month: selectedMonth + 1,
        entitlement_year: selectedYear,
        search_text: searchTextInput,
        department: selectedProductGroupCode,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setShopEmployeeLeaveLoadingState(false);
        const stateRecord: AppRecord = {
          currentPage: 1,
          currentIndex: 0,
          nextPageUrl: response["employee_entitlements"]["next_page_url"] ?? "",
          totalRecord: 0,
          loadingStatus: response["employee_entitlements"]["next_page_url"] != null ? AppRecordStatus.loaded : AppRecordStatus.noLoadMore,
        };
        setShopEmployeeLeave(response.employee_entitlements);

        setShopEmployeeLeaveLoading(stateRecord);
      } else {
        console.log(response, "error fetch shop employee ");
      }
    } catch (error) {
      setShopEmployeeLeaveLoadingState(false);

      AppLog.show({
        message: `[getShopEmployeeTimesheetSearch]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  const fetchMoreShopEmployeeLeaveSearch = async ({ next }: { next: string }) => {
    if (!next) return;

    setShopEmployeeLeaveLoading({
      ...loadingProductState,
      loadingStatus: AppRecordStatus.loadingMore,
    });

    try {
      const responses = await RequestApi(next);

      if (responses.status === "success") {
        const newEmployees = responses["employee_entitlements"]["data"];
        const nextPage = responses["employee_entitlements"]["next_page_url"];

        const updatedData = [...(shopEmployeeLeave?.data || []), ...newEmployees];

        setShopEmployeeLeave({
          ...responses["employee_entitlements"],
          data: updatedData,
        });

        setShopEmployeeLeaveLoading({
          ...loadingProductState,
          nextPageUrl: nextPage ?? "",
          loadingStatus: nextPage ? AppRecordStatus.loaded : AppRecordStatus.noLoadMore,
        });
      }
    } catch (error) {
      console.error("Failed to fetch more employees:", error);
    }
  };

  useEffect(() => {
    if (listRef.current && shopEmployeeLeaveLoading?.nextPageUrl && listRef.current.scrollHeight < window.innerHeight) {
      fetchMoreShopEmployeeLeaveSearch({
        next: shopEmployeeLeaveLoading?.nextPageUrl,
      });
    } else {
      console.log("Error");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopEmployeeLeave?.data]);

  useEffect(() => {
    const savedView = localStorage.getItem("leave");
    if (savedView) {
      setView(savedView);
    }
    getShopEmployeeLeaveSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTextInput, selectedProductGroupCode, selectedYear, selectedMonth + 1, bntSearch]);

  const [storage_host_cluster_Id, setStorage_host_cluster_Id] = useState<any>();
  const [departmentLeave, setDepartmentLeave] = useState<any>();
  const [leaveSetting, setLeaveSetting] = useState<any>();
  const [loadingDepartmentLeave, setloadingDepartmentLeave] = useState<boolean>(false);
  const [attendanceSetting, setAttendanceSetting] = useState<any>({
    early_exception: "",
    late_exception: "",
  });
  const [openPopoverSetting, setOpenPopoverSetting] = useState<number | null>(null);
  const [errorStatus, setErrorStatus] = useState({
    title: "",
    message: "",
  });
  const [warning, setWarning] = useState(false);
  const getShopEmployeeLeaveDepartment = async () => {
    setloadingDepartmentLeave(true);
    try {
      const url = `${RouteApi.getShopEmployeeLeaveDepartment}token=${token}`;
      const data = {
        shop_id: shopId,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setloadingDepartmentLeave(false);
        setDepartmentLeave(response.user_shop_departments);
        setStorage_host_cluster_Id(response.storage_host_cluster);
        setLeaveSetting(response.payroll_setting);
        setAttendanceSetting({
          early_exception: response.attendance_setting.early_exception,
          late_exception: response.attendance_setting.late_exception,
          max_compassionate_leave: response.attendance_setting.max_compassionate_leave,
          max_change_day_off_leave: response.attendance_setting.max_change_day_off_leave,
          max_marriage_leave: response.attendance_setting.max_marriage_leave,
          max_maternity_leave: response.attendance_setting.max_maternity_leave,
          max_paternity_leave: response.attendance_setting.max_paternity_leave,
          max_special_leave: response.attendance_setting.max_special_leave,
          max_suspend_leave: response.attendance_setting.max_suspend_leave,
          max_unpaid_leave: response.attendance_setting.max_unpaid_leave,
          annual_leave: response.attendance_setting.annual_leave,
          sick_leave: response.attendance_setting.sick_leave,
          max_block_leave: response.attendance_setting.max_block_leave,
          max_sick_leave: response.attendance_setting.max_sick_leave,
          max_annual_leave: response.attendance_setting.max_annual_leave,
        });
      } else {
        setloadingDepartmentLeave(false);

        setErrorStatus({
          title: response.status,
          message: response.msg,
        });
        setWarning(true);
      }
    } catch (error) {
      setloadingDepartmentLeave(false);
      AppLog.show({
        message: `[getShopEmployeeLeaveDepartment]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  useEffect(() => {
    getShopEmployeeLeaveDepartment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // -------------------function select all ------------------
  const { indexTimeSheet } = useAppSelector((state) => state.header);
  const allIds = Array.isArray(shopEmployeeLeave?.data) ? shopEmployeeLeave?.data?.map((item: any) => item.id) : [];
  const isAllSelected = allIds.length > 0 && allIds.every((id: any) => selectedProductIds.includes(id));

  const handleToggleSelectAll = () => {
    if (isAllSelected) {
      // Deselect all
      setSelectedProductIds([]);
    } else {
      // Select all
      setSelectedProductIds(allIds);
    }
  };

  const dataTimesheets = [
    {
      id: 1,
      title: "Recalculate",
      label: " Recalculate employee timesheets.",
      icon: (
        <div className="w-8 h-8 flex items-center justify-center bg-green-500 text-white p-2 rounded-full">
          <Calculator />
        </div>
      ),
      description: [
        <>
          <p className="mb-2 font-medium text-sm text-gray-800">Recalculate totals based on the latest timesheet data and changes.</p>
          <ul className="list-disc pl-5 text-sm text-gray-700 space-y-1">
            <li>Updates total working hours, overtime, and payroll calculations.</li>
            <li>Ensures all edits (clock-ins, breaks, shifts) are accurately reflected.</li>
            <li>Run this after importing, editing, or approving timesheets.</li>
          </ul>
        </>,
      ],
    },
  ];
  const [isDailogRecalculateLeave, setIsDailogRecalculateLeave] = useState<boolean>(false);

  const handleClick = (title: string) => {
    if (title === "Recalculate") {
      setIsDailogRecalculateLeave(true);
    } else {
      Snackbar({
        message: `Coming soon ${title}`,
        status: StatusMsg.warning,
      });
    }
    // }, 300); // simulate a short delay
  };
  const [loadingPrint, setLoadingPrint] = useState<boolean>(false);
  const handlePrint = async () => {
    setLoadingPrint(true);
    try {
      const url = `${storage_host_cluster_Id.host_name}/api-mobile-flipflop/v1/get-shop-employee-leave-report?token=${token}`;
      const data = {
        shop_id: shopId,

        entitlement_year: selectedYear,
        search_text: searchTextInput,
        department: selectedProductGroupCode,
        storage_host_cluster_id: storage_host_cluster_Id.id,
      };

      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setLoadingPrint(false);
        const pdfUrl = response?.pdf_url;
        const pdfResponse = await fetch(pdfUrl);
        const blob = await pdfResponse.blob();
        const blobUrl = URL.createObjectURL(blob);
        printJS({ printable: blobUrl, type: "pdf" });
      } else {
        setLoadingPrint(false);

        console.log(response, "error fetch shop employee");
      }
    } catch (error) {
      setLoadingPrint(false);
      setShopEmployeeLeaveLoadingState(false);

      AppLog.show({
        message: `[handlePrint]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const [dailogLeave, setIsDailogLeave] = useState<boolean>(false);

  // =======================new======================
  const [userShopEmployeesLeaveCalculation, setUserShopEmployeesLeaveCalculation] = useState<any>();
  const [loadingEmployeesLeaveCalcaulation, setLoadingEmployeesLeaveCalcaulation] = useState<boolean>(false);
  let statusReset: string = "";

  const getShopEmployeeLeaveCalculation = async () => {
    setLoadingEmployeesLeaveCalcaulation(true);
    try {
      const url = `${RouteApi.getShopEmployeeLeaveCalculation}token=${token}`;
      const data = {
        shop_id: shopId,
        entitlement_month: selectedMonth + 1,
        entitlement_year: selectedYear,
        search_text: searchTextInput,
        department: selectedProductGroupCode,
        payroll_step: "",
        reset: statusReset,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setLoadingEmployeesLeaveCalcaulation(false);
        setUserShopEmployeesLeaveCalculation(response.user_shop_employees.data);
      } else {
        setLoadingEmployeesLeaveCalcaulation(false);

        console.log(response, "error fetch shop employee ");
      }
    } catch (error) {
      setLoadingEmployeesLeaveCalcaulation(false);

      AppLog.show({
        message: `[getShopEmployeeTimesheetSearch]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const [monthDay, setMonthDay] = useState<{ [key: string]: string }>({});
  const [monthDay1, setMonthDay1] = useState<{ [key: string]: string }>({});
  const [monthTable, setMonthTable] = useState<number>();
  const [monthTableClick, setMonthTableClick] = useState<boolean>(false);
  console.log(monthTableClick, "monthTableClick");

  useEffect(() => {
    if (shopEmployeeLeave?.data?.length) {
      const monthMap = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];

      // Adjust month index correctly (assuming monthTable is 1–12)
      const monthIndex: number = monthTableClick === true ? Number(monthTable) - 1 : Number(selectedMonth);

      const currentMonthKey = monthMap[monthIndex] || "unknown";

      console.log(monthIndex, "monthIndex");
      console.log(currentMonthKey, "currentMonthKey");

      const usedKey = `${currentMonthKey}_used_day`;
      const usedDayMap: Record<string, string> = {};

      shopEmployeeLeave.data.forEach((item: any, index: number) => {
        usedDayMap[`${index}-${currentMonthKey}`] = item[usedKey] || "";
      });

      setMonthDay(usedDayMap);
    }
  }, [shopEmployeeLeave, monthTableClick, selectedMonth, monthTable]);

  console.log(selectedMonth + 1, "select month");
  console.log(monthTable, "monthTable");

  const handleChangeMonth = (key: string, val: string) => {
    setMonthDay((prev) => ({
      ...prev,
      [key]: val,
    }));
  };

  const [loadingsubmitUpdateLeaveDeduction, setLoadingsubmitUpdateLeaveDeduction] = useState<boolean>(false);
  const saveUpdateLeaveDeduction = async (key: string, id: number, isEndDay = false) => {
    setLoadingsubmitUpdateLeaveDeduction(true);
    try {
      const working_hour = isEndDay ? monthDay1[key] : monthDay[key];
      const url = `${RouteApi.saveUpdateLeaveDeduction}token=${token}`;
      const data = {
        shop_id: shopId,
        id: id,
        entitlement_year: selectedYear,
        entitlement_month: !monthTableClick ? selectedMonth + 1 : monthTable,
        working_hour: working_hour, // save only 1 value
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setLoadingsubmitUpdateLeaveDeduction(false);
        setOpenPopoverKey(null);
        setMonthTableClick(false);
        setShopEmployeeLeave((prev: any) => ({
          ...prev,
          data: prev.data.map((item: any) => (item.id === response.employee_entitlement.id ? response.employee_entitlement : item)),
        }));
      } else {
        setLoadingsubmitUpdateLeaveDeduction(false);
      }
    } catch (error) {
      console.error("Error saving leave deduction:", error);
      setLoadingsubmitUpdateLeaveDeduction(false);
      AppLog.show({
        message: `[submitUpdateClockTime]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
      setLoadingsubmitUpdateLeaveDeduction(false);
    }
  };

  const [openPopoverKey, setOpenPopoverKey] = useState<{ row: number; month: string } | null>(null);

  const [employeeLeaveDetail, setEmployeeLeaveDetail] = useState<any>();
  const [loadingEmployeeLeaveDetail, setLoadingEmployeeLeaveDetail] = useState<boolean>(false);

  const getShopEmployeeLeaveDetail = async (employee_id: any, leave_type: any) => {
    setLoadingEmployeeLeaveDetail(true);
    try {
      const url = `${RouteApi.getShopEmployeeLeaveDetail}token=${token}`;
      const data = {
        shop_id: shopId,
        employee_id: employee_id,
        leave_type: leave_type,
        entitlement_year: selectedYear,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setLoadingEmployeeLeaveDetail(false);
        setEmployeeLeaveDetail(response.employee_entitlements);
      }
    } catch (error) {
      setLoadingEmployeeLeaveDetail(false);

      AppLog.show({
        message: `[getShopEmployeeLeaveDetail]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  return (
    <BusinessSuiteContentLayout>
      {/* top bar */}
      <div className=" max-w-full z-50 w-auto bg-white sticky top-0 dark:bg-[#020817]">
        <div className={`flex ${window.innerWidth <= 1500 ? "flex-col items-start" : "flex-row  justify-between left-0 items-center "} mb-3 w-full `}>
          <div className="text-start lg:w-auto md:w-auto w-full ">
            <h1 className="font-semibold lg:text-lg md:text-md sm:text-sm">Leave Entitlements</h1>
            <p className=" whitespace-nowrap text-muted-foreground lg:text-md md:text-sm text-[13px]">Streamlining Employee Leave Management with Accuracy and Compliance.</p>
            {/* Inspire your users with bold features and great design. */}
          </div>
          {warning ? (
            ""
          ) : (
            <nav className="border-gray-200 pt-5 flex items-center justify-between">
              <div className="flex items-center gap-3  ">
                {selectProducts && (
                  <div className="flex items-center justify-center px-5 py-2 bg-blue-500 rounded-full text-white">
                    Payroll Selected {selectedProductIds.length} / {allIds.length}
                  </div>
                )}
                <HoverCardDetail
                  title="Create New Payroll "
                  description={
                    <>
                      <p className="mb-2 font-medium text-sm dark:text-white">Add new staff member to your team by entering their personal and job details.</p>
                      <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                        <li>Include contact information, role, and department.</li>
                        <li>Set permissions and access levels if applicable.</li>
                        <li>Ensures staff are properly tracked and managed in the system.</li>
                      </ul>
                    </>
                  }
                >
                  <label
                    onClick={() => {
                      getShopEmployeeLeaveCalculation();
                      setIsDailogLeave(true);
                    }}
                    htmlFor=""
                    className={`hover:border-3 transition-all duration-300 font-semibold rounded-full cursor-pointer lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center text-md border border-gray-300 
                        `}
                  >
                    <Plus className="font-semibold text-xl" />
                  </label>
                </HoverCardDetail>
                <>
                  {!selectProducts ? (
                    <></>
                  ) : (
                    <>
                      {selectedProductIds.length > 0 && (
                        <>
                          <Popover>
                            <PopoverTrigger asChild>
                              <label className=" font-semibold cursor-pointer rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center text-md border border-gray-300">
                                <AlignJustify />
                              </label>
                            </PopoverTrigger>
                            <PopoverContent className="w-80 relative">
                              {dataTimesheets?.map((item: any, index: any) => {
                                return (
                                  <HoverCardDetail title={item.title} description={item.description}>
                                    <div
                                      key={index}
                                      className="gap-3 group  flex items-center px-3 py-2 rounded-md hover:bg-accent cursor-pointer"
                                      onClick={() => {
                                        handleClick(item.title);
                                      }}
                                    >
                                      <span className="group-hover:scale-110 transition-all duration-300">{item.icon}</span>

                                      <div className="flex flex-col ">
                                        <span className="font-medium leading-none lg:text-md md:text-sm text-[13px]">{item.title}</span>
                                        <span className="text-sm text-muted-foreground line-clamp-1">{item.label} </span>
                                      </div>
                                    </div>
                                  </HoverCardDetail>
                                );
                              })}
                            </PopoverContent>
                          </Popover>
                        </>
                      )}
                    </>
                  )}
                </>
                {!selectProducts ? (
                  <>
                    <HoverCardDetail
                      title="Select"
                      description={
                        <>
                          <p className="mb-2 font-medium text-sm dark:text-white">Select this item to perform actions like editing, deleting, or exporting.</p>
                          <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                            <li>Use checkboxes to include or exclude specific records.</li>
                            <li>Selected items can be affected by bulk actions.</li>
                            <li>Combine with “Select All” to manage groups efficiently.</li>
                          </ul>
                        </>
                      }
                    >
                      <label
                        htmlFor=""
                        className="hover:border-3 hover:scale-110 transition-all duration-300 font-semibold  rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                      >
                        <CircleStop
                          onClick={() => {
                            dispatch(setIndexTimeSheet(""));
                            setSelectProducts(true);
                          }}
                          className="text-sm"
                        />
                      </label>
                    </HoverCardDetail>
                  </>
                ) : (
                  <>
                    <HoverCardDetail
                      title="Select all staff timesheets "
                      description={
                        <>
                          <p className="mb-2 font-medium text-sm dark:text-white">Select all staff records or timesheets currently displayed for bulk actions.</p>
                          <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                            <li>Enables efficient management of multiple items at once.</li>
                            <li>Useful for batch printing, editing, or deleting.</li>
                            <li>Double-check your selection before proceeding.</li>
                          </ul>
                        </>
                      }
                    >
                      <label
                        className={`hover:scale-110  transition-all duration-300 font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 
                                  flex items-center justify-center cursor-pointer border 
                                  ${isAllSelected ? "border-blue-500 border-2" : "border-gray-300"} text-md`}
                      >
                        <CircleCheck
                          onClick={() => {
                            handleToggleSelectAll();
                          }}
                          className={`${isAllSelected ? "bg-blue-500 text-white rounded-full" : " rounded-full"} hover:border-3 `}
                        />
                      </label>
                    </HoverCardDetail>
                    <HoverCardDetail
                      title="Select"
                      description={
                        <>
                          <p className="mb-2 font-medium text-sm dark:text-white">Select this item to perform actions like editing, deleting, or exporting.</p>
                          <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                            <li>Use checkboxes to include or exclude specific records.</li>
                            <li>Selected items can be affected by bulk actions.</li>
                            <li>Combine with “Select All” to manage groups efficiently.</li>
                          </ul>
                        </>
                      }
                    >
                      <label
                        htmlFor=""
                        className="hover:border-3 hover:scale-110 transition-all duration-300 font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                      >
                        <CircleOff
                          onClick={() => {
                            setSelectedProductIds([]);
                            setSelectProducts(false);
                          }}
                          className="text-sm"
                        />
                      </label>
                    </HoverCardDetail>
                  </>
                )}
              </div>

              {/* Search & View Switch */}
              {loadingPrint ? (
                <label
                  onClick={() => {
                    handlePrint();
                  }}
                  htmlFor=""
                  className="hover:border-3 hover:scale-110 transition-all  duration-300 ms-3 font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                >
                  <Loader className="animate-spin" />
                </label>
              ) : (
                <HoverCardDetail
                  title="Daily Attendance Detail Report"
                  description={
                    <>
                      <p className="mb-2 font-medium text-sm text-gray-800">View and analyze detailed attendance records for each employee on a daily basis.</p>
                      <ul className="list-disc pl-5 text-sm text-gray-700 space-y-1">
                        <li>Monitor clock-in/out times, absences, and late entries.</li>
                        <li>Track working hours, overtime, and shift compliance.</li>
                        <li>Export reports for HR reviews or payroll processing.</li>
                        <li>Identify patterns for attendance-related issues.</li>
                      </ul>
                    </>
                  }
                >
                  <label
                    onClick={() => {
                      handlePrint();
                    }}
                    htmlFor=""
                    className="hover:border-3 hover:scale-110 transition-all  duration-300 ms-3 font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                  >
                    <PrinterCheck />
                  </label>
                </HoverCardDetail>
              )}
              {/* ------setting------ */}

              <Popover open={openPopoverSetting === 1} onOpenChange={(isOpen) => setOpenPopoverSetting(isOpen ? 1 : null)}>
                <PopoverTrigger asChild>
                  <label
                    htmlFor=""
                    className="hover:border-3  transition-all  duration-300 ms-3 font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                  >
                    <Settings />
                  </label>
                </PopoverTrigger>
                <PopoverContent className=" w-auto  h-[calc(100vh-200px)] overflow-scroll">
                  <TimeSheetSetting attendanceSetting={attendanceSetting} setAttendanceSetting={setAttendanceSetting} setOpenPopoverSetting={setOpenPopoverSetting} />
                </PopoverContent>
              </Popover>
              <div className="flex justify-between items-center ms-5 ">
                <div className="flex items-center gap-4  w-full ">
                  <HoverCardDetail
                    title="Select Month & Year"
                    description={
                      <>
                        <p className="mb-2 font-medium text-sm dark:text-white">Choose a specific month and year to filter, view, or generate time-based records.</p>
                        <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                          <li>View timesheets, attendance, or reports for a selected time period.</li>
                          <li>Useful for monthly payroll, scheduling, or performance tracking.</li>
                          <li>Ensures actions apply to the correct billing or reporting cycle.</li>
                        </ul>
                      </>
                    }
                  >
                    <div className="flex">
                      <Select
                        value={selectedYear.toString()}
                        onValueChange={(val) => {
                          setSelectedYear(Number(val));
                        }}
                      >
                        <SelectTrigger className="w-[180px] py-3 ">
                          <SelectValue placeholder="Select Year" />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectGroup>
                            <SelectLabel>Years</SelectLabel>
                            {years.map((year) => (
                              <SelectItem key={year} value={`${year}`}>
                                {year}
                              </SelectItem>
                            ))}
                          </SelectGroup>
                        </SelectContent>
                      </Select>
                    </div>
                  </HoverCardDetail>
                  <HoverCardDetail
                    title="Select Month & Year"
                    description={
                      <>
                        <p className="mb-2 font-medium text-sm dark:text-white">Choose a specific month and year to filter, view, or generate time-based records.</p>
                        <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                          <li>View timesheets, attendance, or reports for a selected time period.</li>
                          <li>Useful for monthly payroll, scheduling, or performance tracking.</li>
                          <li>Ensures actions apply to the correct billing or reporting cycle.</li>
                        </ul>
                      </>
                    }
                  >
                    <div className="flex">
                      <Select
                        value={selectedMonth.toString()}
                        onValueChange={(val) => {
                          setSelectedMonth(Number(val));
                        }}
                      >
                        <SelectTrigger className="w-[180px] py-3">
                          <SelectValue placeholder="Select Month" />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectGroup>
                            <SelectLabel>Months</SelectLabel>
                            {months.map((month, index) => (
                              <SelectItem key={index} value={`${index}`}>
                                {month}
                              </SelectItem>
                            ))}
                          </SelectGroup>
                        </SelectContent>
                      </Select>
                    </div>
                  </HoverCardDetail>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="flex-1 ms-4 me-2">
                  <div className="relative">
                    <SearchBar
                      placeholder="Search"
                      onValueChange={(value) => {
                        setSearchTextInput(value);
                      }}
                    />
                  </div>
                </div>

                {/* View Toggle Button */}
                <HoverCardDetail
                  title=""
                  description={
                    <>
                      <p className="mb-2 font-medium text-sm dark:text-white">Switch between different layouts to view employee timesheets records in the format you prefer.</p>
                      <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                        <li>
                          <strong>Card View:</strong> Shows each employee timesheets as an individual card with profile info and actions.
                        </li>
                        <li>
                          <strong>Table View:</strong> Displays employees timesheets in a structured table for sorting, scanning, and bulk actions.
                        </li>
                        <li>Use the layout that best suits your workflow or screen size.</li>
                      </ul>
                    </>
                  }
                >
                  <div className="relative">
                    {view === "card" ? (
                      <button
                        onClick={() => changeView("table")}
                        className="font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                      >
                        <Grid2x2 className="font-semibold size-5" />
                      </button>
                    ) : (
                      <button
                        onClick={() => changeView("card")}
                        className="font-semibold rounded-full w-10 h-10 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                      >
                        <WalletCards className="text-xl" />
                      </button>
                    )}
                  </div>
                </HoverCardDetail>
              </div>
            </nav>
          )}
        </div>
        {/* scrollCategories */}
        {warning ? (
          ""
        ) : (
          <div
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            className={`w-full grid grid-cols-1  pt-2 mb-2 pe-2 overflow-x-auto space-x-2 no-scrollbar ${hovered ? "scrollbar-visible" : "scrollbar-custom"}`}
          >
            {/* Hover Overflow Scroll Container */}
            <div className="relative w-full ">
              <div className="flex space-x-2 w-full">
                {/* Add Category */}

                {/* "All" Category */}
                <div
                  onClick={() => {
                    if (selectedProductGroupCode === "All") {
                    }
                    handleClickDepartment({
                      departmentName: "",
                    });
                  }}
                  className={`lg:w-14 lg:h-14 md:w-12 md:h-12 w-10 h-10 px-4 flex items-center justify-center border rounded-md mr-1 cursor-pointer font-semibold ${
                    selectedProductGroupCode === "" ? "bg-gray-200 dark:bg-accent dark:hover:bg-slate-900" : "dark:hover:bg-slate-900"
                  }`}
                >
                  <span className="lg:text-sm md:text-sm text-[12px]">All</span>
                </div>
                {/* Product Categories */}
                <div className="space-x-2 flex">
                  {loadingDepartmentLeave ? (
                    <>
                      <ShimmerDepartmentRender />
                    </>
                  ) : (
                    <>
                      {departmentLeave?.map((department: any) => (
                        <div key={department.id} className="flex items-center">
                          <div
                            className={`flex items-center  w-auto whitespace-nowrap lg:h-14 md:h-12 h-10  border rounded-md cursor-pointer font-semibold 
                                ${
                                  selectedProductGroupCode === (department?.department ? department.department.toString() : "")
                                    ? "dark:bg-accent dark:hover:bg-slate-900 bg-gray-200"
                                    : "dark:hover:bg-slate-900"
                                }`}
                            onClick={() => {
                              handleClickDepartment({
                                departmentName: department?.department ?? "", // Ensure it's a string or fallback to ""
                              });
                            }}
                          >
                            <div className="flex group ">
                              <p className="xl:text-md text-sm font-semibold line-clamp-2 px-2 overflow-hidden flex items-center justify-center">
                                {department?.department ?? "No department"}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {warning ? (
        <div className="flex flex-col gap-2 items-center justify-center h-[70vh] w-full  ">
          <CircleAlert className="text-yellow-500 mx-auto w-[200px] h-[200px]" />
          <h1
            className={`text-[30px] font-semibold   ${
              errorStatus?.title === "success" || errorStatus?.title === "info" ? "text-green-500" : errorStatus?.title === "warning" ? "text-yellow-500" : "text-red-500"
            }`}
          >
            {errorStatus?.title === "success" ? "Success" : errorStatus?.title === "info" ? "Infomation" : errorStatus?.title === "warning" ? "Warning" : "Error"}
          </h1>
          <span className=" text-muted-foreground text-md pt-3 ">{errorStatus?.message}</span>
        </div>
      ) : (
        <div className="pb-3 h-full mt-5 bg-red">
          {view === "card" ? (
            <>
              {shopEmployeeLeaveLoadingState ? (
                <>
                  <ShimmerStaffRender />
                </>
              ) : (
                <InfiniteScroll
                  dataLength={shopEmployeeLeave?.data?.length || 0}
                  next={() =>
                    fetchMoreShopEmployeeLeaveSearch({
                      next: shopEmployeeLeaveLoading.nextPageUrl,
                    })
                  }
                  hasMore={!!shopEmployeeLeaveLoading?.nextPageUrl}
                  loader={
                    <div className="absolute bottom-2 left-0 w-full flex justify-center">
                      <LoaderCircle size={30} className="animate-spin text-yellow-400" />
                    </div>
                  }
                >
                  <>
                    <div ref={listRef} className={`grid  md:grid-cols-5 grid-cols-2 ${window.innerWidth <= 1500 ? "lg:grid-cols-6" : "lg:grid-cols-8"}  gap-y-3 gap-x-2 mb-10   `}>
                      {shopEmployeeLeave?.data?.map((item: any, index: any) => {
                        const monthMap = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
                        const currentMonthIndex = selectedMonth;
                        const prevMonthIndex = currentMonthIndex - 1;
                        const previousEndDayValue = prevMonthIndex >= 0 ? item[`${monthMap[prevMonthIndex]}_end_day`] ?? "-" : "-";
                        const currentMonthKey = monthMap[selectedMonth];
                        const usedKey = `${currentMonthKey}_used_day`;
                        const endKey = `${currentMonthKey}_end_day`;
                        const month = monthMap[selectedMonth];
                        const usedDay = item[usedKey];
                        const endDay = item[endKey];

                        if (!usedDay && !endDay) return null;

                        const editable = usedDay === "0.000";
                        const keyId = `${index}-${month}`;

                        return (
                          <div
                            onClick={() => {
                              if (selectProducts) {
                                setSelectedProductIds((prev) => (prev.includes(item.id) ? prev.filter((id) => id !== item.id) : [...prev, item.id]));
                                return;
                              } else {
                              }
                            }}
                            key={index}
                            className={`group   relative z-1 w-full max-w-sm border rounded-lg  ${selectedProductIds.includes(item.id) ? " " : ""}`}
                          >
                            <div className=" w-full relative overflow-hidden aspect-square ">
                              <ImageUrl className="rounded-t-md w-full h-full  object-cover " src={!item.picture ? noneProfile : item.picture} alt="" />
                              <div
                                className={` ${
                                  selectedProductIds.includes(item.id) ? "bg-white" : ""
                                } w-4 h-4 rounded-full flex items-center justify-center absolute left-2 top-2 text-xl  ${!selectProducts ? " hidden" : " block"}`}
                              >
                                {selectedProductIds.includes(item.id) ? (
                                  <i className=" fa-solid  fa-circle-check text-blue-500 border-2 rounded-full border-white  "></i>
                                ) : (
                                  <i className=" fa-regular fa-circle text-blue-500 border-2 border-transparent rounded-full"></i>
                                )}
                              </div>
                              <div
                                onClick={() => {
                                  setOpenDrawer(1);
                                  getShopEmployeeLeaveDetail(item?.employee_id, item?.leave_type);
                                }}
                                className={`${
                                  selectProducts ? " hidden" : " block"
                                } z-50 cursor-pointer group-hover:scale-110 transition-all duration-300 group-hover:opacity-100 opacity-0 w-8 h-8 flex items-center justify-center bg-green-500 text-white p-2 rounded-full absolute right-2 top-2`}
                              >
                                <BookUser />
                              </div>
                            </div>
                            <div className={`p-4 ${indexTimeSheet === item.id ? "bg-gray-200 dark:bg-[#0e172c] rounded-b-md " : ""} `}>
                              <h5 className="text-md font-semibold line-clamp-2 overflow-hidden h-[20px] ">{item?.local_name}</h5>
                              <span className="text-sm line-clamp-1 overflow-hidden h-[20px]  ">{item?.department}</span>
                              <div key={index} className="flex items-center justify-between mt-2">
                                <div className="flex flex-col justify-between h-[60px]">
                                  <p
                                    className={` text-white px-2 my-1 inline-block rounded-md py-1 ${
                                      item.leave_type === "Annual Leave" ? "bg-green-500" : item.leave_type === "Sick Leave" ? "bg-[#a657f6] " : "bg-red-700"
                                    } font-semibold text-sm  line-clamp-1`}
                                  >
                                    {item.leave_type.replace(/-/g, " ")}
                                  </p>

                                  <p className="font-bold  text-[15px]  text-yellow-500 ">{previousEndDayValue > 0 ? previousEndDayValue + " days" : ""} </p>
                                </div>
                                <div key={index} className="flex flex-col items-end text-end h-[60px] justify-between ">
                                  {/* Used Day Popover */}
                                  <Popover
                                    open={openPopoverKey?.row === index && openPopoverKey?.month === month}
                                    onOpenChange={(isOpen) => setOpenPopoverKey(isOpen ? { row: index, month } : null)}
                                  >
                                    <PopoverTrigger asChild>
                                      {editable ? (
                                        <p onClick={() => setMonthTableClick(false)} className=" text-lg text-black dark:text-white text-end cursor-pointer">
                                          -
                                        </p>
                                      ) : (
                                        <p onClick={() => setMonthTableClick(false)} className={`font-bold text-[15px] text-red-500 cursor-pointer py-2 `}>
                                          {usedDay}
                                        </p>
                                      )}
                                    </PopoverTrigger>
                                    <PopoverContent className="w-auto">
                                      <div className="flex items-center gap-2">
                                        <NumberInput className="w-[150px]" value={monthDay[keyId] || ""} onChange={(val: any) => handleChangeMonth(keyId, val.target.value)} />
                                        <Button className="px-5 dark:text-white" onClick={() => saveUpdateLeaveDeduction(keyId, item.id)}>
                                          {loadingsubmitUpdateLeaveDeduction ? <Loader className="animate-spin" /> : "Save"}
                                        </Button>
                                      </div>
                                    </PopoverContent>
                                  </Popover>

                                  {/* End Day Popover */}
                                  {endDay === "0.000" ? (
                                    <p className=" text-lg text-black dark:text-white">-</p>
                                  ) : (
                                    <p className="text-blue-500 font-bold  text-[15px] ">{endDay}</p>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                      {!shopEmployeeLeave?.next_page_url ? (
                        <p className="absolute bottom-0 left-0 w-full text-center mb-5 flex items-center justify-center">
                          <b>Nothing more to load!</b>
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                  </>
                </InfiniteScroll>
              )}
            </>
          ) : (
            <>
              {shopEmployeeLeave ? (
                <InfiniteScroll
                  dataLength={shopEmployeeLeave?.data?.length || 0}
                  next={() =>
                    fetchMoreShopEmployeeLeaveSearch({
                      next: shopEmployeeLeaveLoading.nextPageUrl,
                    })
                  }
                  scrollThreshold="90%"
                  hasMore={!!shopEmployeeLeaveLoading.nextPageUrl}
                  scrollableTarget="scrollableDiv"
                  loader={
                    <div className="absolute bottom-2 left-0 w-full flex justify-center mt-5">
                      <LoaderCircle size={30} className="animate-spin text-yellow-400" />
                    </div>
                  }
                >
                  <>
                    {shopEmployeeLeaveLoadingState ? (
                      <SkeletonMusicLibrariesTable />
                    ) : (
                      <table className="min-w-full border-collapse mb-20 rounded-md overflow-hidden">
                        <thead className="sticky top-0 left-0 text-xs text-gray-700  bg-gray-300 dark:bg-[#2c3a52] dark:text-gray-400">
                          <tr className="border-none text-[15px] text-start ">
                            <th className=" py-5 px-4 first:rounded-tl-md last:rounded-tr-md ">Image</th>
                            <th className="px-4 text-start ">Staff Name </th>
                            <th className="px-4 text-start">Department</th>
                            <th className="px-4 text-start">Type</th>
                            <th className="px-4 text-end">Jan</th>
                            <th className="px-4 text-end">Feb</th>
                            <th className="px-4 text-end">Mar</th>
                            <th className="px-4 text-end">Apr</th>
                            <th className="px-4 text-end">May</th>
                            <th className="px-4 text-end">Jun</th>
                            <th className="px-4 text-end">Jul</th>
                            <th className="px-4 text-end">Aug</th>
                            <th className="px-4 text-end">Sep</th>
                            <th className="px-4 text-end">Oct</th>
                            <th className="px-4 text-end">Nov</th>
                            <th className="px-4 text-end">Dec</th>
                          </tr>
                        </thead>
                        <tbody ref={listRef}>
                          {shopEmployeeLeave?.data?.map((item: any, index: number) => {
                            return (
                              <tr
                                onClick={() => {
                                  if (selectProducts) {
                                    setSelectedProductIds((prev) => (prev.includes(item.id) ? prev.filter((id) => id !== item.id) : [...prev, item.id]));
                                    return;
                                  } else {
                                    dispatch(setIndexTimeSheet(item.id));
                                  }
                                }}
                                key={index}
                                className={`text-center group cursor-pointer ${
                                  index % 2 === 0 ? "bg-gray-100 dark:bg-[#1e293b] " : "bg-gray-200 dark:bg-[#2c3a52] "
                                } hover:bg-gray-300`}
                              >
                                <td className="relative w-[100px] h-[100px]">
                                  <div
                                    className={` ${
                                      selectedProductIds.includes(item.id) ? "bg-white" : ""
                                    } w-4 h-4 rounded-full flex items-center z-50 justify-center absolute left-[6px] top-[6px] text-xl  ${!selectProducts ? " hidden" : " block"}`}
                                  >
                                    {selectedProductIds.includes(item.id) ? (
                                      <i className=" fa-solid  fa-circle-check text-blue-500 border-2 rounded-full border-white  "></i>
                                    ) : (
                                      <i className=" fa-regular fa-circle text-blue-500 border-2 border-transparent rounded-full"></i>
                                    )}
                                  </div>
                                  <div
                                    onClick={() => {
                                      getShopEmployeeLeaveDetail(item?.employee_id, item?.leave_type);

                                      setOpenDrawer(1);
                                    }}
                                    className={`${
                                      selectProducts ? " hidden" : " block"
                                    } z-50 cursor-pointer group-hover:scale-110 transition-all duration-300 group-hover:opacity-100 opacity-0 w-8 h-8 flex items-center justify-center bg-green-500 text-white p-2 rounded-full absolute right-2 top-2`}
                                  >
                                    <BookUser />
                                  </div>
                                  <ImageUrl src={!item.picture ? noneProfile : item.picture} className="w-[100px] h-[100px] z-1 mx-auto relative" alt="" />
                                </td>
                                <td className="py-2 px-4 text-md text-left align-top">
                                  <p className="text-[15px] font-bold ">{item.card_no}</p>

                                  <p className="text-[15px] ">{item.local_name}</p>
                                  <p className="text-md">{item.english_name}</p>
                                </td>

                                <td className="py-2 px-4 text-md  text-left align-top ">
                                  <p className="text-md line-clamp-1 "> {item?.department}</p>
                                  <p className="text-md "> {item?.position}</p>
                                  <div className="flex items-center gap-1 text-muted-foreground">
                                    <p className="text-md text-nowrap"> {Service.formatTime(item?.starting_time)}</p>
                                    {item?.starting_time && item?.ending_time && "-"}
                                    <p className="text-md text-nowrap "> {Service.formatTime(item?.ending_time)}</p>
                                  </div>
                                </td>
                                <td className="py-2 px-4 text-left align-top">
                                  <p
                                    className={` text-white px-2 my-1 inline-block rounded-md py-1 ${
                                      item.leave_type === "Annual Leave" ? "bg-green-500" : item.leave_type === "Sick Leave" ? "bg-[#a657f6]" : "bg-red-700"
                                    } font-semibold text-sm  line-clamp-1`}
                                  >
                                    {item.leave_type.replace(/-/g, " ")}
                                  </p>
                                  <p className="font-bold  text-[15px]  text-yellow-500  ">{item.no_of_day > 0 ? item.no_of_day + " days" : ""} </p>
                                </td>
                                {["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"].map((month, monthIndex) => (
                                  <td key={month} className="py-2 px-4  text-[15px] text-nowrap text-end align-top">
                                    {/* --- Used Day Popover --- */}
                                    <Popover
                                      open={openPopoverKey?.row === index && openPopoverKey?.month === `${month}-used`}
                                      onOpenChange={(isOpen) => setOpenPopoverKey(isOpen ? { row: index, month: `${month}-used` } : null)}
                                    >
                                      <PopoverTrigger asChild>
                                        <p
                                          onClick={() => {
                                            if (selectProducts) {
                                              return;
                                            } else {
                                              setMonthTable(monthIndex + 1);
                                              setMonthTableClick(true);
                                            }
                                          }}
                                          className="text-[15px] font-semibold text-nowrap "
                                        >
                                          {item[`${month}_used_day`] !== "0.000" ? <p className="text-red-500">{item[`${month}_used_day`]}</p> : "-"}
                                        </p>
                                      </PopoverTrigger>
                                      <PopoverContent className="w-auto">
                                        <div className="grid gap-4">
                                          <div className="space-y-2">
                                            <h4 className="font-medium leading-none">Used Day</h4>
                                          </div>
                                          <div className="flex items-center gap-2">
                                            <NumberInput
                                              className="w-[150px]"
                                              value={monthDay[`${index}-${month}`] || ""}
                                              onChange={(val: any) => handleChangeMonth(`${index}-${month}`, val.target.value)}
                                            />
                                            <Button
                                              className="px-5 dark:text-white"
                                              onClick={() => {
                                                saveUpdateLeaveDeduction(`${index}-${month}`, item.id, false);
                                              }}
                                            >
                                              {loadingsubmitUpdateLeaveDeduction ? <Loader className="animate-spin" /> : "Save"}
                                            </Button>
                                          </div>
                                        </div>
                                      </PopoverContent>
                                    </Popover>

                                    {/* --- End Day Popover --- */}
                                    <p className="text-[15px] font-semibold text-nowrap cursor-pointer  ">
                                      {item[`${month}_end_day`] !== "0.000" ? <p className="text-blue-500">{item[`${month}_end_day`]}</p> : "-"}
                                    </p>
                                  </td>
                                ))}
                              </tr>
                            );
                          })}
                          {!shopEmployeeLeave?.next_page_url ? (
                            <p className="absolute bottom-0 left-0 w-full text-center mb-5 flex items-center justify-center">
                              <b>Nothing more to load!</b>
                            </p>
                          ) : (
                            ""
                          )}
                        </tbody>
                      </table>
                    )}
                  </>
                </InfiniteScroll>
              ) : (
                <></>
              )}
            </>
          )}
        </div>
      )}
      <DailogLeave
        onReset={({ status }) => {
          if (status === "yes") {
            statusReset = "Yes";
            getShopEmployeeLeaveCalculation();
          } else {
            statusReset = "";
          }
        }}
        userShopEmployeesLeaveCalculation={userShopEmployeesLeaveCalculation}
        dailogLeave={dailogLeave}
        setIsDailogLeave={setIsDailogLeave}
        editItemCategories={""}
        filteredData={undefined}
        userShopShiftGroup={undefined}
        setFilteredData={undefined}
        searchTextInput={""}
        loadingEmployeesCalcaulation={loadingEmployeesLeaveCalcaulation}
      />
      <DailogRecalculateLeave
        onUploadSuccess={({ status }) => {
          if (status === "success") {
            setSelectedProductIds([]);
            setSelectProducts(false);
          } else {
          }
        }}
        isDailogRecalculateLeave={isDailogRecalculateLeave}
        setIsDailogRecalculateLeave={setIsDailogRecalculateLeave}
        selectedProductIds={selectedProductIds}
      />
      <Sheet
        open={openDrawer === 1}
        onOpenChange={(isOpen) => {
          setOpenDrawer(isOpen ? 1 : null);
          if (!isOpen) {
            const url = new URL(window.location.href);
            url.searchParams.delete("employee_id");
            url.searchParams.delete("working_data");
            window.history.pushState({}, "", url.toString());
          }
        }}
      >
        <SheetContent className="flex flex-col h-full sm:max-w-[600px] justify-between p-3 pt-[50px]">
          <PageDetailLeave
            selectedYear={selectedYear}
            setOpenDrawer={setOpenDrawer}
            attendanceSetting={attendanceSetting}
            loadingPrint={loadingPrint}
            onUploadSuccess={({ status }) => {
              if (status === "print") {
              } else {
              }
            }}
            dob={dob}
            isDailogTimesheets={false}
            employeeLeaveDetail={employeeLeaveDetail}
            setIsDailogTimesheets={function (value: boolean): void {
              throw new Error("Function not implemented.");
            }}
            employeeTimesheetDetail={undefined}
            setEmployeeTimesheetDetail={undefined}
            shopEmployeeDetailLoadingState={undefined}
            setShopEmployeeDetailLoadingState={undefined}
          />
          <SheetClose className=" hidden" />
        </SheetContent>
      </Sheet>
      <BtnGoToTop />
    </BusinessSuiteContentLayout>
  );
}
